var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrim = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31C4C0",
    d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    d: "M7.501 14.391c-.27 0-.489.202-.489.45 0 .249.22.45.49.45h3.837c.27 0 .489-.201.489-.45 0-.248-.22-.45-.49-.45zm8.652-1.144c.5.274.85 0 .827-.43a.4.4 0 0 0-.059-.21.46.46 0 0 0-.193-.17l-2.12-1.092c-.087-.044-.301-.165-.41-.224-.095-.05-.09-.251 0-.296.089-.044.261-.127.35-.173l2.122-1.087a.5.5 0 0 0 .193-.164.4.4 0 0 0 .058-.216c0-.378-.398-.604-.769-.402l-3.3 1.774a.482.482 0 0 0 0 .855l3.3 1.835Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrim);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/trim.4be4e911.svg";